/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, Navigate } from "react-router-dom";
import { authenticationService } from "../service/authentication";
import { useTranslation } from "react-i18next";
import CustomToast from "../widgets/toaster";
import ResetPassword from "../widgets/resetPasswordModal";
import { IoIosEyeOff } from "react-icons/io";
import { IoIosEye } from "react-icons/io";
import ZebraBrowserPrintWrapper from "zebra-browser-print-wrapper";

const ZebraPrinterSample = () => {
  // const ZebraBrowserPrintWrapper = require("zebra-browser-print-wrapper");
  const printWithZebraPrinter = async () => {
    // return text;
    try {
      let url =
        "https://api.empats-dev.alpha-03.trizentinc.com/uploads/qr/areas/1056bc02b67a2b1c565bd9e7c895e1df.prn";
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      console.log("url=>response", response);
      let zpl = await response.text();
      console.log("url=>zpl", zpl);
      // Create a new instance of the object
      const browserPrint = new ZebraBrowserPrintWrapper();

      // Select default printer
      const defaultPrinter = await browserPrint.getDefaultPrinter();
      console.log("printWithZebraPrinter=>defaultPrinter", defaultPrinter);

      // Set the printer
      browserPrint.setPrinter(defaultPrinter);

      // Check printer status
      const printerStatus = await browserPrint.checkPrinterStatus();
      console.log("printWithZebraPrinter=>printerStatus", printerStatus);

      // Check if the printer is ready
      if (printerStatus.isReadyToPrint) {
        // ZPL script to print a simple barcode
        // zpl = zpl
        //   ? zpl
        //   : `CT~~CD,~CC^~CT~
        //               ^XA~TA000~JSN^LT0^MNW^MTD^PON^PMN^LH0,0^JMA^PR2,2~SD15^JUS^LRN^CI0^XZ
        //               ^XA
        //               ^MMT
        //               ^PW320
        //               ^LL0320
        //               ^LS0
        //               ^FT78,261^BQN,2,5
        //               ^FH\^FDLA,{"id":"56993","serial_number":"MPATS PL32846","type":"plate"}^FS
        //               ^FT245,289^A0I,20,19^FH\^FDMPATS PL32846^FS
        //               ^FT245,265^A0I,20,19^FH\^FDPersonnel Monitoring^FS
        //               ^FT281,51^A0R,20,19^FH\^FDOperator: Ajeesh R Chandran^FS
        //               ^FT25,48^A0R,20,19^FH\^FDDabbed by: Abhiram R Kumar^FS
        //               ^FT263,21^A0I,20,19^FH\^FD16-04-2025 - 11:21:50^FS
        //               ^PQ1,0,1,Y^XZ`;
        console.log("printWithZebraPrinter=>zpl", zpl);

        browserPrint.print(zpl);
      } else {
        console.error(
          "printWithZebraPrinter=>printerStatus=>Error/s",
          printerStatus.errors
        );
        alert(printerStatus.errors);
      }
    } catch (error) {
      console.error("printWithZebraPrinter=>catch=>Error/s", error);
      alert(error);
    }
  };

  return (
    <>
      <div>
        <button onClick={printWithZebraPrinter}>
          Print With Zebra Printer
        </button>
      </div>
    </>
  );
};

export default ZebraPrinterSample;
